import { Input } from "@angular/core";
import { DDocumento } from "@dian/api-formulario";

export interface Question {
    question: string;
    field: string;
    show: boolean;
    nextIfValue?: string;
    isCompleted: boolean;
    resp: string;
    hasSuggested: string;
    totalField: string;
}

export abstract class HandlerComponent {

    @Input('model')
    protected model: DDocumento = new DDocumento();
    protected listQuestions: Question[] = [];

    constructor(
        questions: Question[]
    ) {
        this.listQuestions = questions;
    }

    checkNextQuestion(index: number) {
        const model = this.listQuestions[index];
        if (model.hasOwnProperty('nextIfValue')) {
            if (this.listQuestions.length - 1 === index) return;
            if(this.model.doc.cuerpo[model.field] == model.nextIfValue){
                this.listQuestions[index + 1].show = true;
            }
        }
    }
}


// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/handler-component.ts